module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_both_location_3column@2x-ecd8dbb65e03fd8f95cdf779bb99a463.webp";